/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-test-item-limit.reducer';

export const LabTestItemLimitDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labTestItemLimitEntity = useAppSelector(state => state.labTestItemLimit.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labTestItemLimitDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labTestItemLimit.detail.title">LabTestItemLimit</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.id">Id</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.active">Active</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.lastUpdated}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.cursor}</dd>
          <dt>
            <span id="unitsOfMeasure">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.unitsOfMeasure">Units Of Measure</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.unitsOfMeasure}</dd>
          <dt>
            <span id="resultType">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.resultType">Result Type</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.resultType}</dd>
          <dt>
            <span id="normalRangeLowerLimit">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.normalRangeLowerLimit">Normal Range Lower Limit</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.normalRangeLowerLimit}</dd>
          <dt>
            <span id="normalRangeUpperLimit">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.normalRangeUpperLimit">Normal Range Upper Limit</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.normalRangeUpperLimit}</dd>
          <dt>
            <span id="possibleRangeLowerLimit">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.possibleRangeLowerLimit">Possible Range Lower Limit</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.possibleRangeLowerLimit}</dd>
          <dt>
            <span id="possibleRangeUpperLimit">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.possibleRangeUpperLimit">Possible Range Upper Limit</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.possibleRangeUpperLimit}</dd>
          <dt>
            <span id="template">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.template">Template</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.template}</dd>
          <dt>
            <span id="ageMin">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.ageMin">Age Min</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.ageMin}</dd>
          <dt>
            <span id="ageMax">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.ageMax">Age Max</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.ageMax}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.gender}</dd>
          <dt>
            <span id="weightMin">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.weightMin">Weight Min</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.weightMin}</dd>
          <dt>
            <span id="weightMax">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.weightMax">Weight Max</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.weightMax}</dd>
          <dt>
            <span id="bsaMin">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.bsaMin">Bsa Min</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.bsaMin}</dd>
          <dt>
            <span id="bsaMax">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.bsaMax">Bsa Max</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.bsaMax}</dd>
          <dt>
            <span id="displayPrecision">
              <Translate contentKey="tinyMedicRestApp.labTestItemLimit.displayPrecision">Display Precision</Translate>
            </span>
          </dt>
          <dd>{labTestItemLimitEntity.displayPrecision ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItemLimit.testItem">Test Item</Translate>
          </dt>
          <dd>{labTestItemLimitEntity.testItem ? labTestItemLimitEntity.testItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItemLimit.lab">Lab</Translate>
          </dt>
          <dd>{labTestItemLimitEntity.lab ? labTestItemLimitEntity.lab.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lab-test-item-limit" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-test-item-limit/${labTestItemLimitEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabTestItemLimitDetail;
